import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MatTableColumnDefinitionModel } from '../models/mat-table/mat-table-column-definition.model';
import { CRDatePipe } from './cr-date.pipe';
import { CRTimePipe } from './cr-time.pipe';

@Pipe({ name: 'objectparser' })
export class ObjectParserPipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private crDatePipe: CRDatePipe,
    private crTimePipe: CRTimePipe
  ) { }

  transform(obj: any, options: MatTableColumnDefinitionModel): any {
    let iterator = obj;
    const segments = options.binding.split('.');

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];
      iterator = iterator[segment];

      if (iterator === undefined || iterator === null) {
        return options.nullText === null ? null : options.nullText;
      }
    }

    if (options.valueParser !== undefined) {
      iterator = options.valueParser(iterator, obj);
    }

    if (options.pipes !== undefined) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < options.pipes.length; i++) {
        const pipe = options.pipes[i];
        const args = Array.from(pipe.args);

        args.splice(0, 0, iterator);

        if (pipe.pipe === this.datePipe.constructor) {
          iterator = this.datePipe.transform.apply(this.datePipe, args);
        } else if (pipe.pipe === this.decimalPipe.constructor) {
          iterator = this.decimalPipe.transform.apply(this.decimalPipe, args);
        } else if (pipe.pipe === this.crDatePipe.constructor) {
          iterator = this.crDatePipe.transform.apply(this.crDatePipe, args);
        } else if (pipe.pipe === this.crTimePipe.constructor) {
          iterator = this.crTimePipe.transform.apply(this.crTimePipe, args);
        }
      }
    }

    return iterator;
  }
}
